import { render, staticRenderFns } from "./PeriodCards.vue?vue&type=template&id=15d0b26c&"
import script from "./PeriodCards.vue?vue&type=script&lang=js&"
export * from "./PeriodCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports